import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import PortfolioPage from './components/PortfolioPage';
import Contact from './components/Contact';
import Quote from './components/Quote';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ThreeDDesignsPage from './pages/ThreeDDesignsPage';
import BrandActivationPage from './pages/BrandActivationPage';
import FloatActivationPage from './pages/FloatActivationPage';
import EventsPage from './pages/EventsPage';

// Home Page Component
const HomePage = () => (
  <>
    <Hero />
    <About />
    <Services />
    <Portfolio />
    <Contact />
  </>
);

// Quote Page Component
const QuotePage = () => (
  <div className="pt-32">
    <Quote />
  </div>
);

// Portfolio Page Component
const PortfolioDetailPage = () => (
  <div className="pt-32">
    <PortfolioPage />
  </div>
);

function App() {
  return (
    <Router>
      <div className="App font-poppins">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/portfolio" element={<PortfolioDetailPage />} />
          <Route path="/3d-designs" element={<ThreeDDesignsPage />} />
          <Route path="/brand-activation" element={<BrandActivationPage />} />
          <Route path="/float-activation" element={<FloatActivationPage />} />
          <Route path="/events" element={<EventsPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
